/**
 * Tour anchors. Components mark elements with `data-tour="area.element"` (use
 * `tourTarget`) and tours point at them by the same id, so styling changes
 * never break a tour. Keep ids here so a renamed anchor fails type-checking.
 */
export const TOUR = {
  myGigsTabs: 'my-gigs.tabs',
  myGigsTabInquiries: 'my-gigs.tab.inquiries',
  myGigsTabApplicants: 'my-gigs.tab.applicants',
  myGigsTabOffers: 'my-gigs.tab.offers',
  myGigsTabPayments: 'my-gigs.tab.payments',
  myGigsCreateOffer: 'my-gigs.create-offer',
  applicantActions: 'my-gigs.applicant-actions',

  offerFormPrice: 'offer-form.price',
  offerFormSchedule: 'offer-form.schedule',
  offerFormExpiration: 'offer-form.expiration',
  offerFormFees: 'offer-form.fees',
  offerFormRecipient: 'offer-form.recipient',

  offerSummary: 'offer.summary',
  offerResponse: 'offer.response',
  offerSchedule: 'offer.schedule',
  offerPaymentAction: 'offer.payment-action',
  offerOffPlatform: 'offer.off-platform',
  offerSettlement: 'offer.settlement',
  offerPaymentsList: 'offer.payments-list',

  checklist: 'onboarding.checklist',
} as const;

export type TourTargetId = (typeof TOUR)[keyof typeof TOUR];

export const tourTarget = (id: TourTargetId) => ({ 'data-tour': id });

export const tourSelector = (id: TourTargetId) => `[data-tour="${id}"]`;
